/* PRINTMASTER — pm-cart-fields.js  v1.1
 *
 * v1.1 (19/10/2026): ερώτηση «Θα παραλάβετε από BOX NOW Locker;» πριν το ταμείο, όταν δεν
 * έχει επιλεγεί locker (bnAsk). Rollback: επαναφορά v1.0 (χωρίς το bnAsk και τον έλεγχο στο click).
 *
 * ΓΙΑΤΙ ΥΠΑΡΧΕΙ ΑΥΤΟ ΤΟ ΑΡΧΕΙΟ:
 * Τα snippets pm-invoice-fields.liquid και pm-boxnow-locker.liquid έκαναν render
 * μέσα στο <cart-items-component>. Το Horizon ξαναφέρνει αυτό το section μέσω
 * Section Rendering API και το βάζει στο DOM ως HTML string. Τα inline <script>
 * ΔΕΝ εκτελούνται όταν μπαίνουν με innerHTML → το checkbox τιμολογίου και το
 * κουμπί BOX NOW έμεναν χωρίς listeners. Ο πελάτης έβλεπε τα πεδία αλλά τίποτα
 * δεν άνοιγε, μέχρι να κάνει Ctrl+F5.
 *
 * Η ΛΥΣΗ: το JS φορτώνει ΜΙΑ φορά (από το header, που δεν ξαναγράφεται) και
 * χρησιμοποιεί event delegation στο document. Δεν έχει σημασία πόσες φορές
 * αντικαθίσταται το DOM του καλαθιού — οι listeners ζουν στο document.
 *
 * ΕΞΑΙΡΕΣΗ: ο BOX NOW widget δένεται στο #pm-bn-open τη στιγμή που φορτώνει.
 * Όταν εμφανιστεί νέο κουμπί, ξαναφορτώνουμε το widget script (bnEnsure).
 */
(function () {
  'use strict';
  if (window.__pmCartFields) return;
  window.__pmCartFields = true;

  var AFM_API = 'https://pegasus-shopify-bridge.onrender.com/api/afm/public-lookup';
  var BN_CDN = 'https://widget-cdn.boxnow.gr/map-widget/client/v5.js';
  var BN_PARTNER = 6356;

  var lastLookup = '';

  function id(x) { return document.getElementById(x); }

  function saveAttrs(attrs, cb) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function () { if (cb) cb(null); })
      .catch(function (e) { if (cb) cb(e); });
  }

  /* ============================ ΤΙΜΟΛΟΓΙΟ ============================ */

  var INV_IDS = ['pm-afm', 'pm-doy', 'pm-company', 'pm-activity', 'pm-address', 'pm-zip', 'pm-area'];

  function invEls() {
    var root = id('pm-invoice');
    if (!root) return null;
    return {
      root: root,
      check: id('pm-invoice-check'),
      fields: id('pm-invoice-fields'),
      afm: id('pm-afm'),
      doy: id('pm-doy'),
      company: id('pm-company'),
      activity: id('pm-activity'),
      address: id('pm-address'),
      zip: id('pm-zip'),
      area: id('pm-area'),
      hint: id('pm-afm-hint'),
      status: id('pm-invoice-status'),
      confirm: id('pm-invoice-confirm'),
      confirmBody: id('pm-confirm-body'),
      shipSame: id('pm-ship-same')
    };
  }

  function val(el) { return el && el.value ? String(el.value).trim() : ''; }

  function invHint(e, msg, cls) {
    if (!e.hint) return;
    e.hint.textContent = msg || '';
    e.hint.className = 'pm-invoice__hint' + (cls ? ' ' + cls : '');
  }

  function invStatus(e, msg, cls) {
    if (!e.status) return;
    e.status.textContent = msg || '';
    e.status.className = 'pm-invoice__status' + (cls ? ' ' + cls : '');
  }

  function validAfm(v) {
    if (!/^[0-9]{9}$/.test(v)) return false;
    var s = 0;
    for (var i = 0; i < 8; i++) s += parseInt(v.charAt(i), 10) * Math.pow(2, 8 - i);
    var m = s % 11;
    var d = m === 10 ? 0 : m;
    return d === parseInt(v.charAt(8), 10);
  }

  function invShowConfirm(e) {
    if (!e.confirm) return;
    var l1 = val(e.company);
    var l2 = [], l3 = [];
    if (val(e.afm)) l2.push('ΑΦΜ ' + val(e.afm));
    if (val(e.doy)) l2.push('ΔΟΥ ' + val(e.doy));
    if (val(e.address)) l3.push(val(e.address));
    if (val(e.zip)) l3.push(val(e.zip));
    if (val(e.area)) l3.push(val(e.area));
    var html = l1;
    if (l2.length) html += '<br>' + l2.join(' · ');
    if (l3.length) html += '<br>' + l3.join(', ');
    e.confirmBody.innerHTML = html;
    e.confirm.hidden = false;
  }

  function invHideConfirm(e) { if (e.confirm) e.confirm.hidden = true; }

  function invSave(e, cb) {
    var on = !!(e.check && e.check.checked);
    var same = on && e.shipSame && e.shipSame.checked;
    saveAttrs({
      'Τιμολόγιο': on ? 'Ναι' : '',
      'ΑΦΜ': on ? val(e.afm) : '',
      'ΔΟΥ': on ? val(e.doy) : '',
      'Επωνυμία': on ? val(e.company) : '',
      'Δραστηριότητα': on ? val(e.activity) : '',
      'Διεύθυνση έδρας': on ? val(e.address) : '',
      'ΤΚ έδρας': on ? val(e.zip) : '',
      'Πόλη έδρας': on ? val(e.area) : '',
      'Παράδοση στην έδρα': same ? 'Ναι' : ''
    }, function (err) {
      if (err) invStatus(e, 'Σφάλμα — δοκίμασε ξανά', 'err');
      if (cb) cb();
    });
  }

  function invLookup(e, v) {
    if (v === lastLookup) return;
    lastLookup = v;
    e.afm.classList.add('pm-loading');
    invHint(e, 'Αναζήτηση στοιχείων…', 'load');
    invHideConfirm(e);
    fetch(AFM_API + '?afm=' + encodeURIComponent(v), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var el = invEls();
        if (!el) return;
        el.afm.classList.remove('pm-loading');
        if (d && d.ok) {
          if (d.company) el.company.value = d.company;
          if (d.activity) el.activity.value = d.activity;
          if (d.doy) el.doy.value = d.doy;
          var addr = (d.address || '') + (d.address_no ? ' ' + d.address_no : '');
          if (addr.trim()) el.address.value = addr.trim();
          if (d.zip) el.zip.value = d.zip;
          if (d.area) el.area.value = d.area;
          invHint(el, d.active ? '✓ Ενεργή επιχείρηση' : '⚠ Επιχείρηση ανενεργή/κλειστή', d.active ? 'ok' : 'err');
          invSave(el);
          invShowConfirm(el);
        } else {
          invHint(el, 'Δεν βρέθηκαν στοιχεία — συμπλήρωσέ τα χειροκίνητα', 'err');
          invHideConfirm(el);
        }
      })
      .catch(function () {
        var el = invEls();
        if (!el) return;
        el.afm.classList.remove('pm-loading');
        invHint(el, 'Δεν έγινε αυτόματη αναζήτηση — συμπλήρωσε χειροκίνητα', 'err');
      });
  }

  function invHydrate() {
    var e = invEls();
    if (!e || !e.check) return;
    if (e.fields) e.fields.hidden = !e.check.checked;
    if (e.check.checked && val(e.company) && val(e.afm)) invShowConfirm(e);
    else invHideConfirm(e);
  }

  /* ============================= BOX NOW ============================= */

  function bnEls() {
    var root = id('pm-boxnow');
    if (!root) return null;
    return {
      root: root,
      check: id('pm-bn-check'),
      body: id('pm-bn-body'),
      btnText: id('pm-bn-btn-text'),
      confirm: id('pm-bn-confirm'),
      confirmBody: id('pm-bn-confirm-body'),
      status: id('pm-bn-status')
    };
  }

  function bnStatus(e, msg, cls) {
    if (!e.status) return;
    e.status.textContent = msg || '';
    e.status.className = 'pm-bn-status' + (cls ? ' ' + cls : '');
  }

  /* Το επιλεγμένο locker ζει στα data-* του #pm-boxnow, ώστε να επιβιώνει
     κάθε re-render του καλαθιού (το JS state θα χανόταν). */
  function bnGet() {
    var r = id('pm-boxnow');
    if (!r || !r.dataset.lockerId) return null;
    return { id: r.dataset.lockerId, address: r.dataset.lockerAddress || '', zip: r.dataset.lockerZip || '' };
  }

  function bnSet(sel) {
    var r = id('pm-boxnow');
    if (!r) return;
    if (sel) {
      r.dataset.lockerId = sel.id || '';
      r.dataset.lockerAddress = sel.address || '';
      r.dataset.lockerZip = sel.zip || '';
    } else {
      delete r.dataset.lockerId;
      delete r.dataset.lockerAddress;
      delete r.dataset.lockerZip;
    }
  }

  function bnSave(cb) {
    var e = bnEls();
    if (!e) return;
    var on = !!(e.check && e.check.checked);
    var sel = bnGet();
    saveAttrs({
      BOXNOW: on ? 'Ναι' : '',
      BOXNOW_LOCKER_ID: on && sel ? String(sel.id) : '',
      BOXNOW_LOCKER_ADDRESS: on && sel ? String(sel.address) : '',
      BOXNOW_LOCKER_ZIP: on && sel ? String(sel.zip) : ''
    }, function (err) {
      if (err) bnStatus(e, 'Σφάλμα — δοκίμασε ξανά', 'err');
      if (cb) cb();
    });
  }

  function bnRender() {
    var e = bnEls();
    if (!e) return;
    var sel = bnGet();
    if (e.body) e.body.style.display = e.check && e.check.checked ? '' : 'none';
    if (sel) {
      var txt = sel.address || '';
      if (sel.zip) txt += (txt ? ', ' : '') + sel.zip;
      if (e.confirmBody) e.confirmBody.textContent = txt;
      if (e.confirm) e.confirm.style.display = '';
      if (e.btnText) e.btnText.textContent = 'Αλλαγή σημείου παραλαβής';
    } else {
      if (e.confirm) e.confirm.style.display = 'none';
      if (e.btnText) e.btnText.textContent = 'Επιλογή σημείου παραλαβής';
    }
  }

  window.pmBoxNowAfterSelect = function (s) {
    if (!s) return;
    bnSet({
      id: s.boxnowLockerId || s.id || '',
      address: s.boxnowLockerAddressLine1 || s.addressLine1 || s.address || '',
      zip: s.boxnowLockerPostalCode || s.postalCode || s.zip || ''
    });
    var e = bnEls();
    if (e && e.check && !e.check.checked) e.check.checked = true;
    bnRender();
    bnSave(function () {
      var el = bnEls();
      if (el) bnStatus(el, '✓ Το σημείο καταχωρήθηκε', 'ok');
    });
  };

  /* Ο widget δένεται στο κουμπί όταν φορτώνει. Κάθε νέο κουμπί → νέο load. */
  function bnEnsure() {
    var btn = id('pm-bn-open');
    if (!btn || btn.dataset.bnBound) return;
    btn.dataset.bnBound = '1';
    window._bn_map_widget_config = {
      partnerId: BN_PARTNER,
      parentElement: '#pm-bn-map',
      buttonSelector: '#pm-bn-open',
      type: 'iframe',
      gps: true,
      autoselect: true,
      autoclose: false,
      afterSelect: function (selected) {
        if (window.pmBoxNowAfterSelect) window.pmBoxNowAfterSelect(selected);
      }
    };
    var s = document.createElement('script');
    s.src = BN_CDN + '?pm=' + Date.now();
    s.async = true;
    document.head.appendChild(s);
  }

  /* ===================== BOX NOW: ΕΡΩΤΗΣΗ ΠΡΙΝ ΤΟ ΤΑΜΕΙΟ (v1.1, 19/10/2026) =====================
   * ΓΙΑΤΙ: το checkout (plan GROW) δεν δέχεται χάρτη. Πελάτες πατούσαν «Ολοκλήρωση αγοράς»
   * χωρίς να δουν το πλαίσιο BOX NOW (είναι χαμηλά στο καλάθι), διάλεγαν BOX NOW στο ταμείο
   * και η παραγγελία έφευγε χωρίς locker. Τώρα, αν δεν έχει επιλεγεί locker, ρωτάμε πριν
   * το ταμείο. «Όχι» → συνεχίζει κανονικά. Rollback: επαναφορά του v1.0 του αρχείου.
   */
  var bnAskedNo = false;

  function bnDialog() {
    var dlg = id('pm-bn-ask');
    if (dlg) return dlg;
    var st = document.createElement('style');
    st.textContent =
      '#pm-bn-ask{border:0;border-radius:16px;padding:0;max-width:420px;width:calc(100% - 32px);box-shadow:0 20px 50px rgba(0,0,0,.25);font-family:inherit}' +
      '#pm-bn-ask::backdrop{background:rgba(17,24,39,.55)}' +
      '#pm-bn-ask .pm-bn-ask__in{padding:22px 22px 18px}' +
      '#pm-bn-ask h2{margin:0 0 8px;font-size:19px;line-height:1.3;color:#111827}' +
      '#pm-bn-ask p{margin:0 0 18px;font-size:14.5px;line-height:1.5;color:#374151}' +
      '#pm-bn-ask .pm-bn-ask__btns{display:flex;flex-direction:column;gap:10px}' +
      '#pm-bn-ask button{min-height:48px;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit;padding:0 16px}' +
      '#pm-bn-ask .pm-bn-ask__yes{background:#f5a800;border:0;color:#111827}' +
      '#pm-bn-ask .pm-bn-ask__no{background:#fff;border:1.5px solid #d1d5db;color:#374151}' +
      '#pm-bn-ask button:focus-visible{outline:3px solid #111827;outline-offset:2px}';
    document.head.appendChild(st);
    dlg = document.createElement('dialog');
    dlg.id = 'pm-bn-ask';
    dlg.setAttribute('aria-labelledby', 'pm-bn-ask-title');
    dlg.innerHTML =
      '<div class="pm-bn-ask__in">' +
      '<h2 id="pm-bn-ask-title">Θα παραλάβετε από BOX NOW Locker;</h2>' +
      '<p>Το locker επιλέγεται <strong>εδώ, στο καλάθι</strong> — στο ταμείο δεν εμφανίζεται χάρτης.</p>' +
      '<div class="pm-bn-ask__btns">' +
      '<button type="button" class="pm-bn-ask__yes" data-pm-bn-ask="yes">Ναι, διαλέγω locker</button>' +
      '<button type="button" class="pm-bn-ask__no" data-pm-bn-ask="no">Όχι, άλλος τρόπος αποστολής</button>' +
      '</div></div>';
    document.body.appendChild(dlg);
    return dlg;
  }

  function bnOpenPicker() {
    var e = bnEls();
    if (!e || !e.check) return;
    if (!e.check.checked) {
      e.check.checked = true;
      e.check.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var root = id('pm-boxnow');
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var tries = 0;
    (function clickWhenReady() {
      var btn = id('pm-bn-open');
      if (btn && btn.dataset.bnBound && window._bn_map_widget_config && tries > 3) { btn.click(); return; }
      if (++tries < 25) setTimeout(clickWhenReady, 200);
    })();
  }

  function bnAsk(checkoutBtn) {
    var dlg = bnDialog();
    function onClick(ev) {
      var t = ev.target && ev.target.closest && ev.target.closest('[data-pm-bn-ask]');
      if (!t) return;
      dlg.removeEventListener('click', onClick);
      dlg.close();
      if (t.getAttribute('data-pm-bn-ask') === 'yes') {
        bnOpenPicker();
      } else {
        bnAskedNo = true;
        if (checkoutBtn && checkoutBtn.isConnected) checkoutBtn.click();
        else window.location.href = '/checkout';
      }
    }
    dlg.addEventListener('click', onClick);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    var yes = dlg.querySelector('.pm-bn-ask__yes');
    if (yes) yes.focus();
  }

  /* ========================== DELEGATED EVENTS ======================== */

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.id) return;

    if (t.id === 'pm-invoice-check') {
      var e = invEls();
      if (!e) return;
      if (e.fields) e.fields.hidden = !t.checked;
      if (!t.checked) invHideConfirm(e);
      invSave(e);
      return;
    }
    if (t.id === 'pm-ship-same') {
      var e2 = invEls();
      if (e2) invSave(e2);
      return;
    }
    if (t.id === 'pm-bn-check') {
      if (!t.checked) bnSet(null);
      bnRender();
      bnSave();
      if (t.checked) bnEnsure();
    }
  });

  document.addEventListener('input', function (ev) {
    if (!ev.target || ev.target.id !== 'pm-afm') return;
    var e = invEls();
    if (!e) return;
    var v = e.afm.value.replace(/\D/g, '');
    e.afm.value = v;
    if (v.length === 9) {
      if (validAfm(v)) {
        e.afm.classList.remove('pm-err');
        invLookup(e, v);
      } else {
        e.afm.classList.add('pm-err');
        invHint(e, '✗ Μη έγκυρο ΑΦΜ', 'err');
        invHideConfirm(e);
      }
    } else {
      e.afm.classList.remove('pm-err', 'pm-loading');
      invHint(e, '', '');
      lastLookup = '';
      invHideConfirm(e);
    }
  });

  /* focusout αντί για blur: το blur δεν κάνει bubble */
  document.addEventListener('focusout', function (ev) {
    var t = ev.target;
    if (!t || !t.id || INV_IDS.indexOf(t.id) === -1) return;
    var e = invEls();
    if (!e) return;
    invSave(e);
    if (e.check && e.check.checked && val(e.company) && val(e.afm)) invShowConfirm(e);
  });

  /* Τα πεδία ζουν μέσα σε drawer/dialog — σταματάμε τα keydown/click ώστε να
     μην τα αρπάξουν τα shortcuts του theme. */
  ['keydown', 'click'].forEach(function (type) {
    document.addEventListener(type, function (ev) {
      var t = ev.target;
      if (t && t.id && (INV_IDS.indexOf(t.id) !== -1)) ev.stopPropagation();
    });
  });

  /* Checkout: guard BOX NOW + prefill τιμολογίου μέσω URL (plan GROW) */
  function checkoutUrl(e) {
    var params = [];
    var same = e.shipSame && e.shipSame.checked;
    if (same) {
      if (val(e.company)) params.push('checkout[shipping_address][company]=' + encodeURIComponent(val(e.company)));
      if (val(e.address)) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(val(e.address)));
      if (val(e.zip)) params.push('checkout[shipping_address][zip]=' + encodeURIComponent(val(e.zip)));
      if (val(e.area)) params.push('checkout[shipping_address][city]=' + encodeURIComponent(val(e.area)));
    } else if (val(e.company)) {
      params.push('checkout[shipping_address][company]=' + encodeURIComponent(val(e.company)));
    }
    return params.length ? '/checkout?' + params.join('&') : '/checkout';
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var btn = t.closest('#checkout, [name="checkout"], .cart__checkout-button');
    if (!btn) return;

    var bn = bnEls();
    if (bn && bn.check && bn.check.checked && !bnGet()) {
      ev.preventDefault();
      ev.stopPropagation();
      bnStatus(bn, 'Διάλεξε σημείο παραλαβής BOX NOW για να συνεχίσεις', 'err');
      bn.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* v1.1: δεν έχει επιλεγεί locker → ρωτάμε αν θα παραλάβει από BOX NOW */
    if (bn && bn.check && !bn.check.checked && !bnGet() && !bnAskedNo) {
      ev.preventDefault();
      ev.stopPropagation();
      bnAsk(btn);
      return;
    }

    var e = invEls();
    if (e && e.check && e.check.checked && val(e.company)) {
      ev.preventDefault();
      ev.stopPropagation();
      invSave(e, function () { window.location.href = checkoutUrl(e); });
    }
  }, true);

  /* ===================== ΕΠΑΝΑΣΥΓΧΡΟΝΙΣΜΟΣ ΜΕΤΑ ΑΠΟ RE-RENDER ===================== */

  function sync() {
    invHydrate();
    bnRender();
    if (id('pm-bn-check') && id('pm-bn-check').checked) bnEnsure();
  }

  document.addEventListener('cart:update', sync);
  document.addEventListener('CartUpdateEvent', sync);

  /* Το section rendering αντικαθιστά κόμβους χωρίς event — MutationObserver
     είναι ο μόνος αξιόπιστος τρόπος να το πιάσουμε. */
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; sync(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
